export const normalisePathname = (path?: string | null): string => {
  return path?.replace(/^\/us(\/|$)/, "/") ?? "/"
}
